module.exports = __webpack_public_path__ + "static/img/2.d0a69502.png";